import { AbstractCounter } from './AbstractCounter';
import { CurrencyName, ResourceName } from '../../../core/managers/Inventory';

export class LivesCounter extends AbstractCounter {
  constructor(parent?: PIXI.Container) {
    super(parent);
  }

  protected initParams(): void {
    this.iconName = 'heart_icon@2x';
    this.resourceName = ResourceName.Lives;
  }
}